
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"35","height":"35"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('linearGradient',{attrs:{"id":"a","y1":".5","x2":"1","y2":".5","gradientUnits":"objectBoundingBox"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#921418"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#f06368"}})])]),_c('g',{attrs:{"transform":"translate(-1458 -902)"}},[_c('circle',{attrs:{"cx":"17.5","cy":"17.5","r":"17.5","transform":"translate(1458 902)","fill":"url(#a)"}}),_c('path',{attrs:{"d":"M1477.519 919.5l4.837-4.838a1.5 1.5 0 10-2.121-2.121l-4.837 4.838-4.838-4.838a1.5 1.5 0 10-2.121 2.121l4.837 4.838-4.837 4.837a1.5 1.5 0 102.121 2.121l4.838-4.837 4.837 4.837a1.5 1.5 0 002.121-2.121z","fill":"#fff"}})])])
          )
        }
      }
    